import { isMotionValue } from "../../utils/motion-value.mjs";
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}
export {
  isWillChangeMotionValue
};
